import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import  moment from 'moment';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs/operators';

@Injectable()
export class ModifyResponseInterceptor implements HttpInterceptor {
    constructor() {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        req = this.convertDateTimeToIsoString(req);

        return next.handle(req).pipe(
          filter(res => res instanceof HttpResponse),
          map((res: any) => {
            if (res.body != null) {
              res.body = res.body.data;
            }
            return res;
          })
        );
    }

    protected convertDateTimeToIsoString(req: HttpRequest<any>) {
      for(var key in req.body) {
        if (moment.isMoment(req.body[key])) {
          req.body[key] = req.body[key].utc(true).toISOString();
        }
      }
      return req;
    }
}
